module.exports = __webpack_public_path__ + "static/assets/04bc701e6911ba0288abe6ad05b4a87d.png";